<script>
export default {
  props: {
    translationKey: String,
    img: String,
    link: String,
    // 'cover' fills the image area, 'contain' keeps transparent images (e.g. 3D book renders) whole
    fit: {type: String, default: 'cover'},
  },

  computed: {
    key() {
      return `portfolio.entries.${this.translationKey}`;
    },

    // "extra" lines (time, role, ...) are rendered as small tags
    tags() {
      return this.$te(`${this.key}.extra`)
          ? this.$t(`${this.key}.extra`).split('\n').filter(line => line.trim())
          : [];
    }
  }
}
</script>

<template>
  <a :href="link" target="_blank" rel="noopener" class="project">
    <div class="project-media" :class="`fit-${fit}`">
      <img :src="require('@/assets/portfolio/' + img)" :alt="$t(`${key}.title`)" loading="lazy">
    </div>

    <div class="project-body">
      <h3 class="project-title">{{ $t(`${key}.title`) }}</h3>
      <p class="project-text">{{ $t(`${key}.text`) }}</p>

      <ul v-if="tags.length" class="project-tags">
        <li v-for="tag in tags" :key="tag">{{ tag }}</li>
      </ul>
    </div>
  </a>
</template>

<style scoped>
.project {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-radius: 1rem;
  background: #fff;
  border: 1px solid rgba(17, 17, 17, 0.08);
  box-shadow: 0 2px 10px rgba(17, 17, 17, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.project:hover {
  transform: translateY(-6px);
  border-color: var(--bs-primary);
  box-shadow: 0 16px 36px rgba(13, 110, 253, 0.18);
}

.project-media {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: linear-gradient(135deg, #eaf2ff 0%, #f6f9ff 100%);
}

.project-media img {
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.fit-cover img {
  object-fit: cover;
  object-position: top;
}

.fit-contain img {
  object-fit: contain;
  padding: 1.25rem;
}

.project:hover .project-media img {
  transform: scale(1.06);
}

.project-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1.25rem 1.5rem 1.5rem;
}

.project-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.project-text {
  font-size: 1rem;
  line-height: 1.55;
  color: #444;
  margin-bottom: 1rem;
}

.project-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  list-style: none;
  padding-left: 0;
  margin-top: auto;
  margin-bottom: 0;
}

.project-tags li {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  color: #fff;
  background: var(--bs-primary);
}

/* the global stylesheet enlarges every <p> on small screens; keep card text readable instead */
@media only screen and (max-width: 991px) {
  .project-text {
    font-size: 1.05rem;
  }

  .project-title {
    font-size: 1.5rem;
  }
}

@media (hover: none) {
  .project:hover {
    transform: none;
  }
}
</style>
